// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"src/styles/variables/colors.css\"","absolugrey":"#42495B","Input":"styles-module--Input--3Ks6a"};